ZONES = [
    {
        name: 'Africa',
        code: 'africa',
        order: 4,
        regions: [
            {code: 'za', order: 1,},
            {code: 'afgac', order: 2,},
        ]
    },
    {
        name: 'North America',
        code: 'north-america',
        order: 1,
        regions: [
            {code: 'us', order: 1,},
            {code: 'ca', order: 2,},
            {code: 'mx', order: 3,},
            {code: 'cam', order: 4,},
            {code: 'nagac', order: 5,},
        ]
    },
    {
        name: 'South America',
        code: 'south-america',
        order: 2,
        regions: [
            {code: 'br', order: 1,},
            {code: 'co', order: 2,},
            {code: 'ec', order: 3,},
            {code: 'sagac', order: 4,},
            {code: 'cl', order: 5,},
        ]
    },
    {
        name: 'Oceania',
        code: 'oceania',
        order: 6,
        regions: [
            {code: 'au', order: 1,},
            {code: 'nz', order: 2,},
            {code: 'ocgac', order: 3,},
        ]
    },
    {
        name: 'Asia',
        code: 'asia',
        order: 5,
        regions: [
            {code: 'gcn', order: 1,},
            {code: 'jp', order: 2,},
            {code: 'kr', order: 3,},
            {code: 'my', order: 4,},
            {code: 'sg', order: 5,},
            {code: 'ph', order: 6,},
            {code: 'ru', order: 7,},
            {code: 'th', order: 8,},
            {code: 'ae', order: 9,},
            {code: 'asgac', order: 10,},
            {code: 'in', order: 11,},
            {code: 'kz', order: 12,},
        ]
    },
    {
        name: 'Europe',
        code: 'europe',
        order: 3,
        regions: [
            {code: 'eu', order: 1,},
            {code: 'il', order: 2,},
            {code: 'ru', order: 3,},
            {code: 'ua', order: 4,},
            {code: 'eugac', order: 5,},
            {code: 'kz', order: 6,},
        ]
    }
]
